export enum AuthMode {
    Cookie = 1,
    Bearer = 2
}